export enum SearchFilterMode {
    //EXPANDED = "expanded",
    COLLAPSED = "collapsed"
}
